module.exports = __webpack_public_path__ + "img/client_relation_up.b1843518.svg";